<form [formGroup]="modbusRegisterSignalForm">
  <div class="row py-2 row-table-style">

    <div class="col-3">
      <div class="form-group mb-0">
        <ng-select formControlName="dataType"
          [items]="ALLOWED_DATA_TYPES"
          (change)="onChangeDataType($event)"
          (focusout)="onUpdateSignalProperties()">
        </ng-select>
        @if (formControls.dataType.errors) {
          <div class="invalid-feedback">
            <span translate>Data type required</span>
          </div>
        }
      </div>
    </div>

    <div class="col-3">
      <div class="form-group mb-0">
        <input type="text" formControlName="name" class="form-control"
          [ngClass]="{'is-invalid': formControls.name.errors}"
          (focusout)="onUpdateSignalProperties()">
          @if (formControls.name.errors) {
            <div class="invalid-feedback">
              <span translate>Signal name required</span>
            </div>
          }
        </div>
      </div>

      <div class="col-3">
        <div class="form-group mb-0">
          <ng-select formControlName="order"
            [items]="byteOrder" (change)="onChangeByteOrder($event)"
            (focusout)="onUpdateSignalProperties()">
          </ng-select>
          @if (formControls.order.errors) {
            <div class="invalid-feedback">
              <span translate>Byte order required</span>
            </div>
          }
        </div>
      </div>

      <div class="col">
        <div class="form-group mb-0">
          <div class="input-group">
            <input formControlName="bitmask" type="number" class="form-control"
              [min]="BITMASK_MIN" [max]="getMax(signal.type)"
              [ngClass]="{'is-invalid': formControls.bitmask.errors}"
              (focusout)="onUpdateSignalProperties()">
              <div class="input-group-append">
                <span class="input-group-text" placement="top" ngbTooltip="0x{{decimalToHex(signal.bitmask)}}">
                  <span class="fa-solid fa-hashtag"></span>
                </span>
              </div>
              @if (formControls.bitmask.errors) {
                <div class="invalid-feedback">
                  <span translate>Baudrate required</span>
                </div>
              }
            </div>
          </div>
        </div>

        <div class="col-auto text-right">
          <button aria-label="remove signal" class="btn btn-outline-danger" title="Remove signal" (click)="removeSignal()">
            <span class="fa-solid fa-trash" aria-hidden="true"></span>
          </button>
        </div>

      </div>
    </form>